import React from 'react';
import ResultsHeader from './ResultsHeader';
import SearchChips from './SearchChips';
import ResultsToolbar from './ResultsToolbar';
import JobListingCard from './JobListingCard';
import Pagination from './Pagination';

interface SearchResultsProps {
  jobListings: any[];
  pagination: any;
  filters: any;
  isLoading: boolean;
  onFilterChange: (filters: any) => void;
  onRemoveFilter: (filterKey: string, value?: any) => void;
  currentUserId?: number;
  onShowMobileFilters: () => void;
}

const SearchResults: React.FC<SearchResultsProps> = ({
  jobListings,
  pagination,
  filters,
  isLoading,
  onFilterChange,
  onRemoveFilter,
  currentUserId,
  onShowMobileFilters
}) => {
  const hasActiveFilters = () => {
    return filters.keyword || 
           filters.skill_ids?.length || 
           filters.occupation_ids?.length || 
           filters.industry_ids?.length ||
           filters.characteristic_ids?.length ||
           filters.prefecture_id ||
           filters.city_id ||
           filters.station_id ||
           filters.workstyle_types?.length ||
           filters.availability_types?.length ||
           filters.price_range ||
           filters.payment_site ||
           filters.settlement_hours ||
           filters.interview_count_max ||
           filters.published_within;
  };

  return (
    <div>
      {/* SP用フィルタボタン */}
      <div className="d-lg-none mb-3">
        <button 
          className="btn btn-outline-primary w-100"
          onClick={onShowMobileFilters}
        >
          <i className="bi bi-funnel me-2"></i>
          検索条件を指定
        </button>
      </div>

      {/* 検索条件チップ */}
      {hasActiveFilters() && (
        <SearchChips 
          filters={filters}
          onRemoveFilter={onRemoveFilter}
        />
      )}

      {/* 結果ヘッダー */}
      <ResultsHeader 
        totalCount={pagination?.total_count || 0}
        from={pagination?.from || 0}
        to={pagination?.to || 0}
      />

      {/* ツールバー（件数表示 + 並び替え） */}
      <ResultsToolbar 
        pagination={pagination}
        sort={filters.sort}
        onSortChange={(sort) => onFilterChange({ sort })}
      />

      {/* ローディング表示 */}
      {isLoading && (
        <div className="text-center py-5">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">読み込み中...</span>
          </div>
        </div>
      )}

      {/* 求人一覧 */}
      {!isLoading && jobListings.length > 0 && (
        <div className="row">
          {jobListings.map((job) => (
            <div key={job.id} className="col-12 mb-3">
              <JobListingCard 
                job={job}
                currentUserId={currentUserId}
              />
            </div>
          ))}
        </div>
      )}

      {/* 求人が見つからない場合 */}
      {!isLoading && jobListings.length === 0 && (
        <div className="text-center py-5">
          <div className="bg-white rounded shadow-sm p-5">
            <i className="bi bi-search fs-1 text-muted mb-3 d-block"></i>
            <h5 className="mb-3">求人が見つかりませんでした</h5>
            <p className="text-muted">別のキーワードや条件で検索してみてください。</p>
          </div>
        </div>
      )}

      {/* ページネーション */}
      {!isLoading && jobListings.length > 0 && pagination && (
        <Pagination 
          pagination={pagination}
          onPageChange={(page) => onFilterChange({ page })}
        />
      )}
    </div>
  );
};

export default SearchResults;
